import { CodeComponentPropertyDefinition } from "./SDKCodeComponentPropertyDefinition";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class CodeComponent {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.idInVersion = model.id;
        this.id = model.persistentId;
        this.designSystemVersionId = model.designSystemVersionId;
        this.exportName = model.exportName;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.properties = Object.entries(model.properties).reduce((acc, [key, value]) => {
            acc[key] = new CodeComponentPropertyDefinition(value);
            return acc;
        }, {});
    }
}
